<template>
  <div class="user">
		<div class="balance">
			<div class="amt-title">可用余额</div>
			<div class="amt">{{balanceAmt}}</div>
		</div>
    <div class="item-list">
      <van-cell title="余额明细" icon="balance-list-o" is-link @click="link('/balance-detail')"></van-cell>
    </div>
		<van-form @submit="onSubmit">
			<van-radio-group v-model="rechargeAmt">
				<van-cell-group>
				  <van-cell v-for="(item,index) in rechargeRules" :title="'充'+toYuan(item.amt) + '送' + toYuan(item.giveAmt)">
						<template #right-icon>
							<van-radio :name="item.amt" checked-color="#ee0a24"/>
						</template>
					</van-cell>
				</van-cell-group>
			</van-radio-group>
		  <div style="margin: 16px;">
		    <van-button round block type="primary" native-type="submit">充值</van-button>
		  </div>
		</van-form>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {weChatGetTicked} from "@/api";
import BalanceApi from '../../api/balance'
import wx from 'weixin-js-sdk'

export default {
  name: "user",
  components: {},
  data() {
    return {
			balanceAmt: 0,
			rechargeAmt: 10000,
			rechargeRules: []
		}
  },
  computed: {
  },
  created() {
  },
  mounted() {
		BalanceApi.get().then(res => {
			if (res.ok) {
				this.balanceAmt = (res.data.amt / 100).toFixed(2)
			}
		})
		BalanceApi.getRules().then(res => {
			if (res.data) {
				this.rechargeRules = JSON.parse(res.data)
			}
		})
  },
  destroy() {
  },
  methods: {
		toYuan(fen) {
			return (fen / 100).toFixed(2)
		},
    link(type) {
      this.$router.push(type)
    },
		onSubmit() {
			if (this.rechargeAmt) {
				//金额转换成分
				BalanceApi.recharge(this.rechargeAmt).then(res => {
					this.authorize(res.data)
				})
			}
		},
    authorize(params) {
			let _this = this
      const redirect_uri = window.location.href.split('#')[0]
      weChatGetTicked({
        url: redirect_uri
      }).then(res => {
        const {appId, timestamp, noncestr, signature} = res
        wx.config({
          debug: false,
          appId: appId,
          timestamp: timestamp,
          nonceStr: `${noncestr}`,
          signature: signature,
          jsApiList: ['chooseWXPay']
        })
        wx.ready(res => {
          wx.checkJsApi({/*检查微信支付是否验证通过*/
            jsApiList: ['chooseWXPay'],
            success: res => {
              /*微信支付*/
              wx.chooseWXPay({
                appId: params.appId,
                timestamp: params.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                nonceStr: params.nonceStr, // 支付签名随机串，不长于 32 位
                package: params.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                signType: params.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                paySign: params.paySign, // 支付签名
                success: function () {
                  _this.$toast('支付成功')
									BalanceApi.get().then(res => {
										if (res.ok) {
											_this.balanceAmt = (res.data.amt / 100).toFixed(2)
										}
									})
                },
                cancel: function (res) {
                  _this.$toast('您取消了支付')
                }
              });
            },
            fail: err => {
              console.log('check api fail:', err)
            }
          })
        })
      })
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../../components/icon/iconfont.css';
.user {
  padding: 38px 32px;
  position: relative;
	.balance {
		padding: 30px 0;
		width: 100%;
		background-color: #FFF;
		text-align: center;
	}
  .item-list {
		border-top: 1px solid #ebedf0;
		margin-bottom: 30px;
  }
}
</style>
